import { call, put, takeLatest } from 'redux-saga/effects';
import { ACTIONS_TYPES } from "../utils/constants";
import {getMeters, registerMeter } from '../utils/requests';
import { registerMeterFailed, registerMeterSuccess, fetchMetersSuccess, fetchMetersFailed } from '../actions/stockController';

export function* fetchMetersWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.FETCH_METERS_REQUEST, fetchMetersRequestWatcher);
}

function* fetchMetersRequestWatcher() {
  try {
    const response = yield call(getMeters);

    yield put(fetchMetersSuccess(response.data));
  } catch(error) {
    let errorPayload = {};
    if (error.response) {
      errorPayload = error.response.data;
    }
    yield put(fetchMetersFailed(errorPayload));
  }
  
}


export function* registerMeterWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.REGISTER_METER_REQUEST, registerMeterRequestWatcher);
}



function* registerMeterRequestWatcher(action) {
    try {
      const { payload } = action;
      const response = yield call(registerMeter, payload);

      yield put(registerMeterSuccess(response.data));
      console.log("createdMeter");
      

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      console.log("registerMeterError: ",error.response);
      
      yield put(registerMeterFailed(errorPayload));
    }
}